<div class="file-upload-container">
	<!-- File input (hidden, must be at component level for global access) -->
	<input #fileInputElement type="file" multiple [accept]="acceptedTypes()" (change)="onFileSelect($event)" class="hidden-file-input" data-testid="file-upload-file-input" />

	<!-- File Type Selector (hierarchy mode only) -->
	@if (uploadMode() === 'hierarchy') {
		<div class="file-type-selector">
			<label class="file-type-label" for="file-type-select">File type</label>
			<p-select
				inputId="file-type-select"
				[options]="fileTypeOptions()"
				[ngModel]="selectedFileType()"
				(ngModelChange)="selectedFileType.set($event)"
				[filter]="true"
				scrollHeight="10rem"
				optionLabel="label"
				optionValue="value"
				placeholder="Select file type"
				[style]="{ width: '100%' }"
				data-testid="file-upload-file-type-select"
			/>
		</div>
	}

	<!-- Drag and Drop Zone -->
	<div
		class="drop-zone"
		[class.drag-over]="isDragOver() && hasEnvironment()"
		[class.has-files]="hasHadFiles()"
		[class.disabled]="!hasEnvironment()"
		(dragover)="hasEnvironment() && onDragOver($event)"
		(dragleave)="hasEnvironment() && onDragLeave($event)"
		(drop)="hasEnvironment() && onDrop($event)"
		(click)="hasEnvironment() && fileInputElement.click()"
		(keydown.enter)="hasEnvironment() && fileInputElement.click()"
		tabindex="0"
		role="button"
		data-testid="file-upload-drop-zone-button"
	>
		@if (!hasHadFiles()) {
			<div class="drop-zone-content">
				<i class="pi pi-cloud-upload drop-icon"></i>
				<p class="drop-text">
					<span class="select-link">Click to upload</span>
					or drag and drop
				</p>
				<small class="drop-hint">{{ acceptedTypes() }} (max. {{ formatFileSize(maxFileSize()) }})</small>
				@if (isMainSuite()) {
					<small class="drop-hint">Accepts XCOM readout files TXT. Only one readout file per test suite.</small>
				}
			</div>
		} @else {
			<div class="drop-zone-content-compact">
				<i class="pi pi-plus drop-icon-small"></i>
				<p class="drop-text-small">Drop more files or click to select</p>
			</div>
		}
	</div>

	<!-- File Queue List -->
	@if (hasHadFiles()) {
		<div class="file-list">
			@for (item of fileQueue(); track item.id) {
				<div class="file-item" [class.uploading]="item.status === 'uploading'">
					<!-- File Icon -->
					<div class="file-icon">
						<i [class]="getStatusIcon(item)" [style.color]="getStatusColor(item)"></i>
					</div>

					<!-- File Info -->
					<div class="file-info">
						<div class="file-name">{{ item.file.name }}</div>
						<div class="file-details">
							<span class="file-size">{{ formatFileSize(item.file.size) }}</span>
							<span class="file-status" [style.color]="getStatusColor(item)">
								{{ getStatusMessage(item) }}
							</span>
						</div>

						<!-- Progress Bar (only show when uploading) -->
						@if (item.status === 'uploading') {
							<p-progressBar [value]="item.progress" [showValue]="false" [style]="{ height: '4px', marginTop: '0.5rem' }" />
						}
					</div>

					<!-- Action Buttons -->
					<div class="file-actions">
						@if (item.status === 'error') {
							<p-button
								icon="pi pi-refresh"
								severity="secondary"
								[text]="true"
								[rounded]="true"
								size="small"
								(onClick)="retryFile(item)"
								pTooltip="Try again"
								tooltipPosition="left"
								data-testid="file-upload-retry-button"
							/>
						}

						@if (item.status === 'pending' || item.status === 'error') {
							<p-button
								icon="pi pi-times"
								severity="secondary"
								[text]="true"
								[rounded]="true"
								size="small"
								(onClick)="removeFile(item)"
								pTooltip="Remove"
								tooltipPosition="left"
								data-testid="file-upload-remove-button"
							/>
						}
					</div>
				</div>
			}
		</div>
	}
</div>

<!-- Replace XCOM File Confirmation Dialog -->
<app-confirmation-dialog
	[(visible)]="xcomReplaceDialogVisible"
	header="Replace Readout File?"
	message="A readout file is already attached.<br>Do you want to replace it?<br><strong>Only one readout file is allowed per test suite.</strong>"
	confirmLabel="Replace"
	confirmSeverity="warn"
	(confirmed)="confirmXcomReplace()"
	(cancelled)="cancelXcomReplace()"
	data-testid="file-upload-xcom-replace-dialog"
/>

<!-- Overwrite File Confirmation Dialog -->
<app-confirmation-dialog
	[(visible)]="overwriteDialogVisible"
	header="Overwrite Confirmation"
	[message]="overwriteDialogMessage()"
	confirmLabel="Overwrite"
	confirmSeverity="warn"
	(confirmed)="confirmOverwrite()"
	(cancelled)="cancelOverwrite()"
	data-testid="file-upload-overwrite-dialog"
/>
